import { html } from 'lit';
import { distributionMetadata, distributionValues } from '../types.js';
import { styleMap } from 'lit/directives/style-map.js';
import { register as _registerElement } from "../../../elements/one-ux-icon/register-element.js";
_registerElement("icon-1e2b433868a8fe12a213db20c2086dc6");
export function DistributionLegend({
  metadata,
  values,
  direction,
  hideExcludedInLegend = false
}: {
  metadata: distributionMetadata[];
  values?: distributionValues;
  direction?: 'horizontal' | 'vertical';
  hideExcludedInLegend?: boolean;
}) {
  const itemHeight = '16px';
  const lineGap = '0px';
  return html`
    <div
      class="legend"
      aria-hidden="true"
      style=${styleMap({
    display: 'flex',
    gap: direction == 'vertical' ? 'var(--one-ux-spacing--300) 0' : `${lineGap} var(--one-ux-spacing--200)`,
    'flex-direction': direction == 'vertical' ? 'column' : null,
    'flex-wrap': 'wrap',
    'align-content': 'flex-start',
    'overflow-wrap': 'anywhere',
    color: 'var(--one-ux-palette--brand-neutral-600)',
    'min-height': direction == 'vertical' ? null : `calc(var(--one-ux-visualization-element--min-number-of-lines) * ${itemHeight} + (var(--one-ux-visualization-element--min-number-of-lines) - 1) * ${lineGap})`
  })}
    >
      ${metadata.filter(x => !(hideExcludedInLegend && x.exclude)).sort((a, b) => a.exclude === b.exclude ? 0 : a.exclude ? 1 : -1).map(x => html`<div
              class="legend--item"
              style="
                display: flex;
                align-items: flex-start;
                white-space: nowrap;
                gap: var(--one-ux-spacing--100);
                height: ${itemHeight}
              "
            >
              <icon-1e2b433868a8fe12a213db20c2086dc6
                size="100"
                icon=${x.icon.name}
                set=${x.icon.set}
                style=${styleMap({
    color: x.color
  })}
              ></icon-1e2b433868a8fe12a213db20c2086dc6>
              <div
                class="legend one-ux-typography--label-400"
                style="line-height: var(--one-ux-size--icon-100); margin: 0;"
              >
                ${values ? values[x.key] || 0 : x.name}
              </div>
            </div>`)}
    </div>
  `;
}